import Modal from "react-bootstrap/Modal";
import "./css/modalEnrollment.css";
import Enrollment from "./compoment/Enrollment";

export default function ModalEnrollment(props) {
  return (
    <div className="modal-enrolment">
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Body>
          <button className="close" onClick={props.onHide}>
            <i className="fas fa-times"></i>
          </button>
          <div className="enrolment">
            <Enrollment onSuccess={props.onHide} subject={props.subject} />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
